module.exports = __webpack_public_path__ + "media/images/projects/golikovvv-e4d8faeba633f9802592b87904568cde.jpg";